import BaseComponent from '../abstracts/BaseComponent';

export default class LoaderComponent extends BaseComponent {
  constructor(element) {
    super(element);

    this.createFullScreenLoader();
    this.attachLoader('a', 'click');
  }

  createFullScreenLoader() {
    const loaderContainer = document.createElement('div');
    loaderContainer.id = 'full-screen-loader';
    loaderContainer.classList.add('loader', 'hidden');

    const spinner = document.createElement('div');
    spinner.classList.add('mu-admin-spinner');

    loaderContainer.appendChild(spinner);

    document.body.appendChild(loaderContainer);
  }

  attachLoader(selectors, eventType) {
    document.querySelectorAll(selectors).forEach(link => {
      link.addEventListener(eventType, () => {
        this.showLoader();
        setTimeout(() => {
          this.hideLoader(); // hide loader after 3 seconds
        }, 3000);
      });
    });
  }

  showLoader() {
    const loader = document.querySelector('#full-screen-loader');
    if (loader) {
      loader.classList.remove('hidden');
    }
  }

  hideLoader() {
    const loader = document.getElementById('full-screen-loader');
    if (loader) {
      loader.classList.add('hidden');
    }
  }
}
